<template>
  <component
    :is="icon.name"
    v-bind="icon"
    :active="active"
    @ready="$emit('ready')"
  />
</template>

<script>
const Bag = () => import('@/Scripts/components/shared/svg/Assets/Bag.vue');
const Bell = () => import('@/Scripts/components/shared/svg/Assets/Bell.vue');
const Box = () => import('@/Scripts/components/shared/svg/Assets/Box.vue');
const Cancel = () => import('@/Scripts/components/shared/svg/Assets/Cancel.vue');
const Chat = () => import('@/Scripts/components/shared/svg/Assets/Chat.vue');
const Check = () => import('@/Scripts/components/shared/svg/Assets/Check.vue');
const Close = () => import('@/Scripts/components/shared/svg/Assets/Close.vue');
const Dot = () => import('@/Scripts/components/shared/svg/Assets/Dot.vue');
const DotMultiColor = () => import('@/Scripts/components/shared/svg/Assets/DotMultiColor.vue');
const DotTransform = () => import('@/Scripts/components/shared/svg/Assets/DotTransform.vue');
const DotTransformSmall = () => import('@/Scripts/components/shared/svg/Assets/DotTransformSmall.vue');
const DownTransform = () => import('@/Scripts/components/shared/svg/Assets/DownTransform.vue');
const Email = () => import('@/Scripts/components/shared/svg/Assets/Email.vue');
const Heart = () => import('@/Scripts/components/shared/svg/Assets/Heart.vue');
const HiggIcons = () => import('@/Scripts/components/shared/svg/Assets/HiggIcons.vue');
const InfoTransform = () => import('@/Scripts/components/shared/svg/Assets/InfoTransform.vue');
const Loading = () => import('@/Scripts/components/shared/svg/Assets/LoadingCircle.vue');
const LoadingDots = () => import('@/Scripts/components/shared/svg/Assets/LoadingDots.vue');
const Lock = () => import('@/Scripts/components/shared/svg/Assets/Lock.vue');
const Loyalty = () => import('@/Scripts/components/shared/svg/Assets/Loyalty.vue');
const Minus = () => import('@/Scripts/components/shared/svg/Assets/Minus.vue');
const More = () => import('@/Scripts/components/shared/svg/Assets/More.vue');
const Plus = () => import('@/Scripts/components/shared/svg/Assets/Plus.vue');
const Tag = () => import('@/Scripts/components/shared/svg/Assets/Tag.vue');
const PlusTransform = () => import('@/Scripts/components/shared/svg/Assets/PlusTransform.vue');
const Progress = () => import('@/Scripts/components/shared/svg/Assets/Progress.vue');
const Search = () => import('@/Scripts/components/shared/svg/Assets/Search.vue');
const Star = () => import('@/Scripts/components/shared/svg/Assets/Star.vue');
const UploadCloud = () => import('@/Scripts/components/shared/svg/Assets/UploadCloud.vue');
const User = () => import('@/Scripts/components/shared/svg/Assets/User.vue');
const Zoom = () => import('@/Scripts/components/shared/svg/Assets/Zoom.vue');
const No = () => import('@/Scripts/components/shared/svg/Assets/Flags/No.vue');
const Ca = () => import('@/Scripts/components/shared/svg/Assets/Flags/Ca.vue');
const Us = () => import('@/Scripts/components/shared/svg/Assets/Flags/Us.vue');
const Gb = () => import('@/Scripts/components/shared/svg/Assets/Flags/Gb.vue');
const Se = () => import('@/Scripts/components/shared/svg/Assets/Flags/Se.vue');
const De = () => import('@/Scripts/components/shared/svg/Assets/Flags/De.vue');
const List = () => import('@/Scripts/components/shared/svg/Assets/List.vue');
const Tiles = () => import('@/Scripts/components/shared/svg/Assets/Tiles.vue');

export default {
  name: 'SvgComponent',
  components: {
    Bag,
    Bell,
    Box,
    Cancel,
    Chat,
    Check,
    Close,
    Dot,
    DotMultiColor,
    DotTransform,
    DotTransformSmall,
    DownTransform,
    Email,
    Heart,
    HiggIcons,
    InfoTransform,
    Loading,
    LoadingDots,
    Lock,
    Loyalty,
    Minus,
    More,
    Plus,
    PlusTransform,
    Progress,
    Search,
    Star,
    UploadCloud,
    User,
    Zoom,
    No,
    Ca,
    Us,
    Gb,
    Se,
    De,
    Tag,
    List,
    Tiles
  },
  props: {
    icon: {
      type: Object,
      default () {
        return {
          name: '',
          color: this.Globals.colors.primary,
          size: 16,
          type: ''

        };
      }
    },
    active: Boolean
  }
};
</script>
